
import * as React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import PlantingPlannerForm from './PlantingPlannerForm';
import SeasonalPlantingPlannerTabs from './SeasonalPlantingPlannerTabs';

export function App() {
    return (
        <Grid container spacing={2}>
            <Grid className='hideOnPrint' item xs={12}>
                <Paper square={true} elevation={4}>
                    <PlantingPlannerForm />
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <SeasonalPlantingPlannerTabs /> 
            </Grid>
        </Grid>
    );
}